import { LambdaClient } from '@aws-sdk/client-lambda';
import { S3Client } from '@aws-sdk/client-s3';
import { DocumentDisplayer } from './DocumentDisplayer';
import colorPhoto from '../../Mitchell2017.jpeg';

interface DocumentsSectionProps {
  lambdaClient: LambdaClient;
  s3Client: S3Client;
  isAdmin: boolean;
  isPostCollege: boolean;
  isAdvisor: boolean;
}

export const DocumentsSection = (props: DocumentsSectionProps) => {
  return (
    <div className="p-8 sm:p-12">
      <img
        className="w-full h-64 sm:h-80 lg:h-[28rem] object-cover object-[center_40%] rounded-[2rem] shadow-md mb-8 sm:mb-12"
        src={colorPhoto}
        alt="Color Photo"
      />
      <div className="w-full flex flex-col relative">
        <DocumentDisplayer
          lambdaClient={props.lambdaClient}
          s3Client={props.s3Client}
          isAdmin={props.isAdmin}
          isPostCollege={props.isPostCollege}
          isAdvisor={props.isAdvisor}
        />
      </div>
    </div>
  );
};
